import { getPerformanceRoute, getV2EditorRoute, getPopupEditorRoute } from 'FormsUI/lib/RouteGenerators';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
export const getStatusKey = (isPublished, publishAt) => {
  if (!isPublished) {
    return 'draft';
  }
  if (publishAt && !isPublished) {
    return 'scheduled';
  }
  return 'published';
};
export const getHrefForFormType = (id, formType, isPublished) => {
  if (isPublished) {
    return getPerformanceRoute(id);
  }
  switch (formType) {
    case FormTypes.HUBSPOT:
      return getV2EditorRoute(id);
    case FormTypes.FLOW:
      return getPopupEditorRoute(id);
    default:
      return getPerformanceRoute(id);
  }
};